const ValidationError = ({ children }) => <p className="text-danger small mb-0" >{children}</p>

export default ValidationError;